'use client';

import { AutocompleteBase } from '../autocompleteBase/AutocompleteBase';

import type { TNameType } from '../../types/components/components.type';
import type { TAutocompleteProps } from './autocomplete.type';

/**
 * Simplified version (Narrowing the interface) of AutocompleteBase
 *
 * @see AutocompleteBase src/components/autocompleteBase/AutocompleteBase.tsx
 */
export const Autocomplete = <TName extends TNameType>({
  name,
  value,
  availableValues = [],
  handleChange,
  handleBlur,
  label,
  size,
  color,
  className,
  helperText,
  multiple = false,
  disabled = false,
  errorMessage = '',
  freeSolo = false,
  loading = false,
}: TAutocompleteProps<TName>) => (
  <AutocompleteBase
    name={name}
    label={label}
    handleChange={handleChange}
    handleBlur={handleBlur}
    value={value}
    className={className}
    size={size}
    color={color}
    availableValues={availableValues}
    errorMessage={errorMessage}
    helperText={helperText}
    disabled={disabled}
    multiple={multiple}
    freeSolo={freeSolo}
    loading={loading}
  />
);
